import React from "react";
import { Check, RefreshCw, Unplug, Wallet } from "lucide-react";

// Blocco "Fonte PayPal": stato collegamento + azioni (sync / dati test / scollega).
export const PayPalBlock = ({ paypal, ppBusy, onSync, onSeed, onDisconnect }) => (
  <div
    className="mb-4 rounded-[12px] border bg-[#0D0D14] p-4"
    style={{ borderColor: paypal?.connected ? "rgba(46,169,224,0.32)" : "rgba(255,255,255,0.08)" }}
    data-testid="paypal-block"
  >
    <div className="flex items-center gap-3">
      <span
        className="flex h-9 w-9 items-center justify-center rounded-[7px] border"
        style={{ borderColor: "rgba(46,169,224,0.4)", background: "rgba(46,169,224,0.1)", color: "#2EA9E0" }}
      >
        <Wallet size={16} />
      </span>
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2">
          <p className="text-sm font-light text-white/90">PayPal</p>
          {paypal?.connected && paypal?.mode && (
            <span
              className="caps-tag rounded-[4px] px-1.5 py-0.5"
              style={{ color: "#2EA9E0", border: "1px solid rgba(46,169,224,0.4)" }}
            >
              {paypal.mode === "test" ? "TEST" : "LIVE"}
            </span>
          )}
          {paypal && !paypal.configured && (
            <span className="caps-tag rounded-[4px] border border-[#FFD60A]/40 px-1.5 py-0.5 text-[#FFD60A]/80">
              NON CONFIG.
            </span>
          )}
        </div>
        <p
          className="caps-tag mt-0.5"
          style={{ color: paypal?.connected ? "rgba(46,169,224,0.8)" : "rgba(255,255,255,0.4)" }}
          data-testid="paypal-status-text"
        >
          {paypal === null
            ? "Verifico…"
            : paypal.connected
            ? `Collegato · ${paypal.tx_count} movimenti`
            : "Non collegato"}
        </p>
      </div>
      {paypal?.connected && <Check size={16} className="shrink-0" style={{ color: "#2EA9E0" }} />}
    </div>

    {paypal !== null && (
      <div className="mt-3 flex gap-2">
        <button
          onClick={onSync}
          disabled={!!ppBusy}
          data-testid="paypal-sync-button"
          className="mono flex h-10 flex-1 items-center justify-center gap-2 rounded-[6px] border bg-transparent text-[10px] font-medium uppercase tracking-[0.16em] active:scale-[0.98] disabled:opacity-50"
          style={{ borderColor: "rgba(46,169,224,0.4)", color: "#2EA9E0" }}
        >
          <RefreshCw size={13} className={ppBusy === "sync" ? "animate-spin" : ""} />
          {ppBusy === "sync" ? "Sincronizzo…" : "Sincronizza"}
        </button>
        {!paypal.connected ? (
          <button
            onClick={onSeed}
            disabled={!!ppBusy}
            data-testid="paypal-seed-button"
            className="mono flex h-10 items-center justify-center gap-1.5 rounded-[6px] border border-white/[0.12] bg-transparent px-3 text-[10px] font-medium uppercase tracking-[0.16em] text-white/60 hover:bg-white/[0.04] active:scale-[0.98] disabled:opacity-50"
          >
            {ppBusy === "seed" ? "Carico…" : "Dati di test"}
          </button>
        ) : (
          <button
            onClick={onDisconnect}
            disabled={!!ppBusy}
            data-testid="paypal-disconnect-button"
            className="mono flex h-10 items-center justify-center gap-1.5 rounded-[6px] border border-white/[0.12] bg-transparent px-3 text-[10px] font-medium uppercase tracking-[0.16em] text-white/45 hover:bg-white/[0.04] active:scale-[0.98] disabled:opacity-50"
          >
            <Unplug size={12} />
            {ppBusy === "disconnect" ? "…" : "Scollega"}
          </button>
        )}
      </div>
    )}

    {paypal && !paypal.connected && (
      <p className="mono mt-2 text-[10px] leading-4 tracking-[0.04em] text-white/30">
        Sandbox: usa "Dati di test" per provare subito, oppure abilita "Transaction Search"
        sull'app PayPal per il sync reale.
      </p>
    )}
  </div>
);
